module.exports = __webpack_public_path__ + "static/brand01-29cf5f9dc643699205fdaf83852d394b.png";